import api from "@common/components/addressMultiple/service/addressMultiple.service";
import * as types from "@common/components/addressMultiple/store/addressMultiple.actionType";
import addressActions from "@common/components/addressMultiple/store/addressMultiple.actions";

import {
  takeEvery,
  call,
  put
} from "redux-saga/effects";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.ADDRESS_MULTIPLE_GET, getByCep)
  yield takeEvery(types.ADDRESS_MULTIPLE_GETCEPCIDADE, getByCepPorCidade)
}

function* getByCep(action) {
  const { payload } = action;

  const result = yield call(api.getByCep, { data: payload.data.state });
  yield put(addressActions.setAddress({ hash: payload.data.hash, state: { ...result.data, UF: result.data.Uf || result.data.UF } }));
}

function* getByCepPorCidade(action) {
  const { payload } = action;

  const result = yield call(api.getByCepPorCidade, payload);
  yield put(addressActions.setAddress(result.data));
}